import { ICategory } from "@evennt-tech/api-v2-core";

const allCategory: ICategory = {
  title: "All",
  id: "all",
  glossaryId: "",
  priority: 0,
  createdAt: new Date().toISOString(),
  updatedAt: new Date().toISOString(),
};

export default allCategory;
